let PlayersDropzone = {
    SHOW_DROPZONE: 'SHOW_DROPZONE',
    HIDE_DROPZONE: 'HIDE_DROPZONE',
    DROPZONE_IS_LOADING: 'DROPZONE_IS_LOADING',
    DROPZONE_IS_NOT_LOADING: 'DROPZONE_IS_NOT_LOADING',
};

export default PlayersDropzone;
